import React from 'react';
import { Link } from 'react-router-dom';
import styles from './InvoicingMini.module.css';

function InvoicingMini() {
  return (
    <div className={styles.card}>
      <div className={styles.topStatBox}>
        <div>
          <div className={styles.statLabel}>Outstanding Invoices</div>
          <span className={styles.statNumber}>3</span>
        </div>
        <button className={styles.expandIcon}>⛶</button>
      </div>

      <h3 className={styles.cardTitle}>Invoicing</h3>
      <span className={styles.cardCategory}>Billing Overview</span>
      <p className={styles.cardDescription}>
        Manage invoice requests, track billing history, and stay on top of account balances with ease.
      </p>

      <div className={styles.cardFooter}>
        <Link to="/dashboard/resellers/invoicing" className={styles.viewLink}>View full page →</Link>
      </div>
    </div>
  );
}

export default InvoicingMini;
